import { render } from "./H3.vue?vue&type=template&id=7752ce50&scoped=true"
const script = {}

import "./H3.vue?vue&type=style&index=0&id=7752ce50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7752ce50"]])

export default __exports__